/* eslint-disable */
import { useEffect } from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from "../../../components/features/Datatable";
import Filter from "./Filter";
import { setSlugs } from "../../../slices/help";
import { getInboundListing } from "../../../slices/logisticSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { hasAuthority } from "../../../../utils/authorities";
import ChatModule from "../../Chat";
import { addPatientList, addPhaseList } from "../../../slices/chat";
import { capitalizeWords } from "../../../../utils/utils";

const filterConfig = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
  apheresis_date: {
    label: "Apheresis Date",
  },
  cycle: {
    label: "Cycle", 
  },
  dashboardFilter: {
    label: "Dashboard Filter",
    enum: {
      true: "Active",
    }
  }
};

const InBound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const dispatch = useDispatch();
  const { inboundListing } = useSelector(
    (state) => state.bmrLogistic
  );
  const isFromLsmDispatchedDashboard = location.state?.lsmDispatched_dashboard === 1 ? 1 : 0;
  const isFromDashboard = isFromLsmDispatchedDashboard === 1;

  const updateFilter = (filter) => {
    fetchUsers(filter);
  };

  const fetchUsers = async (filter) => {
    const isDashboardFilterActive = filter && filter.dashboardFilter === true;

    const payload = {
      ...(filter || {}),
      lsmDispatched_dashboard: isDashboardFilterActive ? isFromLsmDispatchedDashboard : 0,
    };
    delete payload.dashboardFilter;

    await dispatch(getInboundListing(payload));
  };

  const columns = [
    {
      id: "subject_code",
      name: "Subject/Patient ID",
      selector: (row) =>
        row.subject_patient_id ? row.subject_patient_id : "N/A",
      sortable: true,
    },
    {
      id: "subject_name",
      name: "Subject/Patient Name",
      selector: (row) => (row.subject_name ? capitalizeWords(row.subject_name) : "N/A"),
      sortable: true,
    },
    {
      id: "product_phase",
      name: "Product/Phase",
      selector: (row) =>
        row.product_name && row.phase_name
          ? `${(row.product_name)}/${capitalizeWords(row.phase_name)}`
          : "N/A",
      sortable: true,
    },
    {
      id: "phase_type",
      name: "Type",
      selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
      sortable: true,
    },
    {
      id: "hospital_name",
      name: "Hospital/Site",
      selector: (row) => (row.hospital_name ? row.hospital_name : "N/A"),
      sortable: true,
    },
    {
      id: "scheduled_apheresis_date",
      name: "Apheresis Date",
      selector: (row) =>
        row.scheduled_apheresis_date
          ? moment(row.scheduled_apheresis_date).format("DD/MM/YYYY")
          : "N/A",
      sortable: true,
    },
    {
      id: "shipment_status",
      name: "Status",
      selector: (row) =>
        row.shipment_status ? (
        <p className={`${ row.shipment_status === "Shipped"
              ? "text-[#00B278]"
              : row.shipment_status === "Pending"
              ? "text-[#FF2023]"
              : "text-[#24B9DF]" 
          } font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]`}
        > {row?.shipment_status}
            </p>
        ) : (
          "N/A"
        ),
      sortable: true,
    },
     { id: "stage", name: "Stage", selector: row => row.stage ? row.stage : "N/A", sortable: true },

        {
    id: "cycleObject", 
    name: "Cycle",
    selector: (row) => {
        if (row.cycleObject) {
            const cycleValue =  row.cycleObject;
            return (
                <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium border border-blue-300 whitespace-nowrap">
                    {cycleValue}
                </span>
            );
        }
        return "N/A";
    },
    sortable: true,
},
    {
      name: "Action",
      selector: (row) => (
        <Button
          onClick={() =>
            navigate(`/bmr/logistics-management/in-bound/view/${row?.qr_code_generated_id}/${row?.feasibility_id}?batch=${row.batch_no}`,{
              state: [
            { name: "LSM Inbound", path: location.pathname },
            {
              name: "Details",
              path: `/bmr/logistics-management/in-bound/view/${row?.qr_code_generated_id}/${row?.feasibility_id}?batch=${row.batch_no}`,
            },
            ]
            })
          }
          key={row?.subject_id}
          size="small"
          className="!w-[100px]"
        >
          View Details
        </Button>
      ),
    },
  ];

  useEffect(() => {
    if (hasAuthority(["in-bound-marked-shipped"], bmr_permissions)) {
      dispatch(setSlugs(["lsm-shipped"]));
    }
    return () => {
      dispatch(setSlugs([""]));
    };
  }, []);

  useEffect(() => {
    fetchUsers({ dashboardFilter: isFromDashboard });
  }, [isFromLsmDispatchedDashboard]);

  useEffect(() => {
      const phaseList = inboundListing?.items?.map(op => { return { value: op?.phase_id, label: `${op?.phase_name} (${op?.product_name})`, patient_id: op?.subject_id } })
      const patientList = inboundListing?.items?.map(op => { return { value: op?.subject_id, label: `${op?.subject_name}`, phase_id: op?.phase_id } })
      dispatch(addPatientList(patientList))
      dispatch(addPhaseList(phaseList))
  }, [inboundListing])


  return (
    <Grid
      container
      className="mt-4 ml-0 mr-3 mainDiv"
      rowSpacing={4.5}
      columnSpacing={2.75}
    >
      <Grid item xs={12} sx={{ mt: -2.25 }}>
        {hasAuthority(['in-bound-listing'], bmr_permissions) &&
          <div>
            <DataTable
              columns={columns}
              data={inboundListing}
              title="LSM Inbound"
              FilterComponent={Filter}
              onServerSideChange={updateFilter}
              remote={true}
              filterConfig={filterConfig}
              defaultFilters={isFromDashboard ? { dashboardFilter: true } : null}
            />
            <ChatModule />
          </div>
        }
      </Grid>
    </Grid>
  );
};

export default InBound;
